import { render, staticRenderFns } from "./TestbankInfoFooter.vue?vue&type=template&id=4423576b&"
import script from "./TestbankInfoFooter.vue?vue&type=script&lang=js&"
export * from "./TestbankInfoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4423576b')) {
      api.createRecord('4423576b', component.options)
    } else {
      api.reload('4423576b', component.options)
    }
    module.hot.accept("./TestbankInfoFooter.vue?vue&type=template&id=4423576b&", function () {
      api.rerender('4423576b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Info/TestbankInfoFooter.vue"
export default component.exports